import { render } from "./HomePlatform.vue?vue&type=template&id=50f6c8cd&scoped=true"
import script from "./HomePlatform.vue?vue&type=script&lang=js"
export * from "./HomePlatform.vue?vue&type=script&lang=js"

import "./HomePlatform.vue?vue&type=style&index=0&id=50f6c8cd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f6c8cd"]])

export default __exports__